import { ApiCollectionResponse, GetCollectionQueryParams } from '../../types';
import { ReadPage } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { GetCampaignPagesStaticFilter } from '../../endpoints/campaigns';

export const getCampaignPages = async (
  params: GetCollectionQueryParams<ReadPage, GetCampaignPagesStaticFilter>,
): Promise<ApiCollectionResponse<ReadPage>> => {
  return await tinctApi.campaigns.getCampaignPages(params);
};

export const useGetCampaignPages = (
  params: GetCollectionQueryParams<ReadPage, GetCampaignPagesStaticFilter>,
  options?: Omit<
    UseQueryOptions<ApiCollectionResponse<ReadPage>, ApiError>,
    'queryKey'
  >,
) =>
  useQuery({
    queryKey: ['campaigns', params.staticParams?.campaignId, 'pages', params],
    queryFn: () => getCampaignPages(params),
    ...options,
  });
